import React from 'react';

const TimePicker = ({ onTimeChange, startTime, endTime }) => {
  const handleStartTimeChange = (e) => {
    onTimeChange(e.target.value, endTime);
  };

  const handleEndTimeChange = (e) => {
    onTimeChange(startTime, e.target.value);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', width:'100%',alignItems:'center',justifyItems:'center',margin: '20px 0' }}>
      <div style={{margin:'6px'}}>
        <label>From: </label>
        <input
          type="datetime-local"
          value={startTime}
          onChange={handleStartTimeChange}
        />
      </div>
      <div style={{margin:'6px'}}>
        <label>To: </label>
        <input
          type="datetime-local"
          value={endTime}
          onChange={handleEndTimeChange}
        />
      </div>
    </div>
  );
};

export default TimePicker;
